import React, { Component } from 'react';
import { Button, Glyphicon } from 'react-bootstrap';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { truncateAtFirstComma } from '../utils/utils.js';
require(`../assets/${process.env.PAGE}/css/components/CarSimulationOption.css`);

class CarSimulationOption extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isActive: false,
        }
        this.selectProduct = this.selectProduct.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const { currentAmount, handleSubmitSelectedProduct } = this.props;
        if (currentAmount !== nextProps.currentAmount) {
            handleSubmitSelectedProduct()
            this.setState({ isActive: false })
        }
    }

    selectProduct() {
        this.props.selectProductOption(this.props.car, this.props.formattedOfferName);
    }

    renderCuotas() {
        const { cuotas } = this.props.car;
        if (!cuotas) return null;

        if (typeof cuotas === 'string' || typeof cuotas === 'number') {
            return (
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 car-loan-installments">
                    <span>{`Cuotas: ${cuotas} `}</span>
                </div>
            );
        }
        if (Array.isArray(cuotas)) {
            return (
                <div>
                    <span className="custom-bold-font">Opciones de financiación</span>
                    {cuotas.map((cuota, index) => {
                        let displayText = cuota;
                        if (typeof cuota === 'string') {
                             displayText = truncateAtFirstComma(displayText)
                        }
                        return (
                            <div key={index} className="col-xs-12 col-sm-12 col-md-12 col-lg-12 car-loan-installments">
                                <span>{`${displayText}`}</span>
                            </div>
                        );
                    })}
                </div>
            );
        }
    }

    render() {

        const { car, expanded, finished } = this.props;

        const carDetails =
            <div>
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 car-description">
                    <span >{car.descripcion}</span>
                </div>
                {this.renderCuotas()}
            </div>

        const isActive = this.props.car_selected === this.props.car
        const buttonClasses = !isActive ? "text-center btn-car" : "text-center btn-car btn-car-active";

        return (
            <Button
                className={buttonClasses}
                onClick={this.selectProduct}
                disabled={false}
            >
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 align-center">
                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 no-gutters car-name">
                        <span>{car.marca} {car.modelo}</span>
                    </div>
                    <div className="col-xs-6 col-sm-5 col-md-5 col-lg-5 col-sm-offset-1 col-md-offset-1 col-lg-offset-1 no-gutters car-img">
                        <img alt="Logo" className="" src={car.url_imagenes} />
                    </div>
                </div>
                {expanded && carDetails}
                {finished}
            </Button>
        );
    }
}

const selector = formValueSelector('CarSimulation')

CarSimulationOption = connect(
    state => {
        const car_selected = selector(state, 'car_selected')
        return {
            car_selected
        }
    }
)(CarSimulationOption)

CarSimulationOption.defaultProps = {
  selectProductOption: null,
  formattedOfferName: '',
  finished: null,
};

export default CarSimulationOption;


/** WEBPACK FOOTER **
 ** ./src/components/CarSimulationOption.js
 **/